import { render, staticRenderFns } from "./Comandos.vue?vue&type=template&id=7afa3422"
import script from "./Comandos.vue?vue&type=script&lang=js"
export * from "./Comandos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports